import { Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { IConfig } from '@shared/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    constructor(private apiService: ApiService) {}

    getAllData(): Promise<any> {
        return this.apiService.get('/get/all');
    }

    getAllItems(): Promise<IConfig> {
        return this.apiService.get('/get/config');
    }

    getTemplateConfig(): Promise<IConfig> {
        return this.apiService.get('/get/config?configType=templates');
    }

    updateConfig(item: IConfig): Promise<void> {
        return this.apiService.patch('/update/config', item);
    }
}
